import { axiosClient } from "../api-client";

export function GetBrands({ config }) {
	return axiosClient.get("/v1/brands", config);
}

export function GetBrand({ config }) {
	return axiosClient.post("/v1/brands/detail/profile", {}, config);
}

export function UpdateBrand({ config, body, group }) {
	let url = group === "admin" ? "superadmin" : "admin";

	return axiosClient.patch(`/v1/brands/edit/${url}`, body, config);
}

export function AssignToBrandByAdmin({ config, body }) {
	const brand_id = body._id;
	delete body._id;
	return axiosClient.post(`/v1/brands/${brand_id}/sendmails`, body, config);
}

export function GetPrivacy({ config, body }) {
	return axiosClient.get(`/v1/brands/${body}/termandprivacy`, config);
}

export function SavePrivacy({ config, body }) {
	return axiosClient.post(
		`/v1/brands/${Object.keys(body)[0]}/termandprivacy`,
		body,
		config
	);
}

export function GetBrandInviteList({ config }) {
	return axiosClient.get("/v1/brands/invited/emails/list", config);
}

export function CreateBrand({ config, body }) {
	return axiosClient.post("/v1/brands/create", body, config);
}

export function GetAddressList({ config }) {
	return axiosClient.get("/v1/brands/addresses/list", config);
}

export function AddressCreate({ config, body }) {
	return axiosClient.post("/v1/brands/addresses/create", body, config);
}
export function DeleteAddress({ config, body }) {
	return axiosClient.delete("/v1/brands/addresses/" + body, config);
}

export function GetStriperLink({ config }) {
	return axiosClient.post("/v1/payment/brand/account/links", {}, config);
}

export function GetStriperLinkWithCountry({ config, body }) {
	return axiosClient.post("/v1/payment/account/links", body, config);
}

export function DeleteBrand({ body, config }) {
	return axiosClient.delete("/v1/brands/" + body, config);
}

export function GetBrandBalance({ config }) {
	return axiosClient.get("/v1/payment/brand/balance/retrieve", config);
}

export function GetDomainList({ config }) {
	return axiosClient.get("/v1/brands/whitelist/domains", config);
}

export function GetBrandBalanceHistory({ config, body }) {
	return axiosClient.get("/v1/payment/brand/balance/list", {
		...config,
		params: {
			...config.params,
			...body,
		},
	});
}

export function PostBrandReFund({ config, body }) {
	return axiosClient.post("/v1/payment/brand/refund", body, config);
}

export function PostBrandStripeCredentials({ config, body }) {
	return axiosClient.post(
		"/v1/payment/brand/stripe/credentials",
		body,
		config
	);
}
export function GetBrandStripeSecrets({ config }) {
	return axiosClient.get("/v1/payment/brand/stripe/secrets", config);
}

export function PostTradeIn({ config, body }) {
	return axiosClient.post("/v1/trade-in/brand", body, config);
}
export function GetTradeIn({ config, body }) {
	return axiosClient.get("/v1/trade-in/" + body, config);
}
export function GetTradeInBrand({ config, body }) {
	return axiosClient.get("/v1/trade-in/brand/possible-templates", {
		...config,
		params: {
			...config.params,
			...body,
		},
	});
}

export function PatchTradeInUpdate({ config, body }) {
	const id = body._id;
	delete body._id;

	console.log("body ===> ", body);
	return axiosClient.patch("/v1/trade-in/" + id, body, config);
}
